/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseLoginResponseData } from './genericApiResponseLoginResponseData';
import type { GenericApiResponseLoginResponseMessage } from './genericApiResponseLoginResponseMessage';
import type { GenericApiResponseLoginResponsePagination } from './genericApiResponseLoginResponsePagination';
import type { GenericApiResponseLoginResponseError } from './genericApiResponseLoginResponseError';

export interface GenericApiResponseLoginResponse {
  data?: GenericApiResponseLoginResponseData;
  message?: GenericApiResponseLoginResponseMessage;
  pagination?: GenericApiResponseLoginResponsePagination;
  error?: GenericApiResponseLoginResponseError;
  statusCode?: number;
}
